module.exports = __webpack_public_path__ + "img/btn-swiper-play-on-control-02.29b5b4a7.svg";